module.exports = fox._r("components/strip-notification/fonts/strip-notification.ttf?2a2d6v", __webpack_public_path__ + "_/_/_/root/components/strip-notification/fonts/Lb-ytW7.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/strip-notification/fonts/strip-notification.ttf?2a2d6v
// module id = 577
// module chunks = 4